<div class="tab-pane active" role="tabpanel" id="step1">
    <form [formGroup]="forms">
    <div class="text-center">
        <label
        class="pageMiniHeadings"
        [innerHTML]="
            'CARDOPERATIONS_CARD_INPUT_HEADER_LABEL' | translate
        "
        ></label>
        <br />
        <input
            #onlineChargeAliasBox
            type="text"
            class="input-lg text-center"
            [value]="queryAlias"
            (input)="onChangeQueryAliasNo($event.target.value)"
            maxlength="13"
            id="aliasNumber"
            placeholder="XXXXX-XXXXX-X"
        />
        <br />
        <div *ngIf="isLoading" class="spinner">
            <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
        </div>
        <div class="spacer30"></div>
        <ng-container *ngIf="isProductsReceived">
            <p>{{'CARDOPERATIONS_CHARGE_AMT_SELECT' | translate}}</p>
            <input
                type="number"
                class="input-lg text-center"
                maxlength="5"
                id="aliasNumber"
                placeholder="PKR"
                formControlName="amountForm"
            />
            <ng-container *ngIf="amountErrors.invalid && (amountErrors.dirty || amountErrors.touched)">
                <span class="error-msg" *ngIf="amountErrors.hasError('required')">
                    {{ 'UTILITY_REQUIRED_ERROR' | translate }} 
                </span>
                <span class="error-msg" *ngIf="amountErrors.hasError('amountInvalid')">
                    {{'CARDOPERATIONS_AMOUNT_INVALID_ERROR_1' | translate}}
                    {{ invalidAmountError.min }}
                    {{'CARDOPERATIONS_AMOUNT_INVALID_ERROR_2' | translate}}
                    {{ invalidAmountError.max }}
                </span>
            </ng-container>
            <div class="spacer30"></div>
            <a
                type="submit"
                class="btn-primary center-block btn-lg"
                (click)="onlineCharge_onNextClick()"
                [innerHTML]="'CARDOPERATIONS_ONLINE_CHARGE_NEXT_BUTTON_LABEL' | translate"
            ></a>
        </ng-container>
    </div>
    </form>
</div>